// extracted by mini-css-extract-plugin
export default {"title":"PrescriptionItem__title--vo1l+","desc":"PrescriptionItem__desc--Y0-67","price":"PrescriptionItem__price---Uxgl"};